<template>
  <div class="list-group-item rule-item"
       :class="{ 'list-group-item-action': !isGroup, 'rule-item-group': isGroup, 'active': isActive }"
       :role="!isGroup ? 'button' : null"
       @click.stop="itemClicked">

    <div class="row mr-0 align-items-center">
        <template v-if="isGroup">
          <div class="col-auto">
            <font-awesome-icon v-if="!isRuleItemValid(value)" :icon="['fas', 'exclamation-triangle']" class="text-danger" />
            {{ $t('Webportal.RuleBuilder.Group') }}
          </div>
          <div class="col">
            <b-form-select size="sm"
                           v-model="value.operation"
                           :options="getGroupOperationOptions()"
                           @input="itemChanged"
                           style="width:100px"
                           :disabled="disabled"
            />
          </div>
        </template>
        <template v-else>
          <div class="col">
            <font-awesome-icon v-if="!options.isBusy && !isRuleItemValid(value)" :icon="['fas', 'exclamation-triangle']" class="text-danger" />
            <template v-if="isRuleTypeValid(value.type) && isRuleOperationValid(value.operation)">
              <strong>{{ getRuleTypeText(value.type) }}</strong> {{ getRuleOperationText(value.operation) }}
              <span v-if="options.isBusy" class="mb-3 ps-1">
                <b-spinner small variant="secondary"></b-spinner>
              </span>
              <strong v-else-if="ruleValueObject">
                {{ ruleValueObject.label }}
              </strong>
            </template>
            <span v-else class="text-danger">{{ $t('Webportal.RuleBuilder.InvalidRuleDefinition') }}</span>
          </div>
        </template>
        <div class="col-auto pe-3">
          <b-button v-if="isGroup" variant="secondary" size="sm" @click.stop="addRule" :disabled="disabled">
            <font-awesome-icon :icon="['fas', 'plus']" /> {{ $t('Webportal.RuleBuilder.AddRule') }}
          </b-button>
          <b-button v-if="isGroup" variant="secondary" size="sm" @click.stop="addGroup" :disabled="disabled">
            <font-awesome-icon :icon="['fas', 'plus']" /> {{ $t('Webportal.RuleBuilder.AddGroup') }}
          </b-button>
          <b-button v-if="canDelete" variant="outline-secondary" size="sm" @click.stop="$emit('delete-item', value)" :disabled="disabled">
            <font-awesome-icon :icon="['fas', 'times']" />
          </b-button>
        </div>
    </div>

    <div class="list-group pt-2" v-if="hasChildren">
      <rule-item
        v-for="(childItem, index) in value.children"
        :key="index"
        :value="childItem"
        :options="options"
        :canDelete="value.children.length > 1 || isGroupItem(childItem)"
        @delete-item="deleteItem"
        :disabled="disabled"
      ></rule-item>
    </div>
  </div>
</template>

<script>
import RuleBuilderMixin from './RuleBuilderMixin';

export default {
  name: 'RuleItem',

  mixins: [ RuleBuilderMixin ],

  props: {
    value: { type: Object, default: () => {} },
    disabled: { type: Boolean, default: false },
    canDelete: { type: Boolean, default: true },
    options: { type: Object, default: () => {} },
  },

  data() {
    return {
    }
  },

  computed: {
    isGroup() {
      return this.isGroupItem(this.value);
    },

    isActive() {
      return this.options && this.value === this.options.selectedItem;
    },

    hasChildren() {
      return !_.isEmpty(this.value.children);
    },

    ruleValueObject() {
      return this.getRuleValueObject(this.value);
    },
  },

  methods: {
    isGroupItem(item) {
      return item.type === undefined;
    },

    itemClicked() {
      if (this.options.itemClicked && !this.isGroup)
        this.options.itemClicked(this.value);
    },

    itemChanged() {
      if (this.options.itemChanged)
        this.options.itemChanged(this.value);
    },

    addRule() {
      if (!this.value.children)
        this.value.children = this.value.children || [];

      let item = { type: this.RuleType.Wave, operation: "=", value: null };
      this.value.children.push(item);

      if (this.options.itemAdded)
        this.options.itemAdded(item);
    },

    addGroup() {
      if (!this.value.children)
        this.value.children = [];

      let item = { operation: "and", children: [{ type: this.RuleType.Wave, operation: "=", value: null }] };
      this.value.children.push(item);

      if (this.options.itemAdded)
      {
        this.options.itemAdded(item);
        this.options.itemAdded(item.children[0]);
      }
    },

    deleteItem(item) {
      let index = _.findIndex(this.value.children, item);

      if (index > -1)
      {
        this.value.children.splice(index, 1);
        if (this.options.itemDeleted)
          this.options.itemDeleted(item);
      }
    }
  }
}
</script>

<style>
  .rule-item {
    padding-right: 0px !important;
    min-height: 50px;
  }

  .rule-item-group {
    background-color: #fafafa !important;
  }
</style>
